import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class AlertsService {

  constructor() { }

  alertError(msg: string){
    Swal.fire({
      title: `${msg}`,
      icon: 'error'
    })
  }

  alertSuccess(msg:string){
    Swal.fire({
      title: `${msg}`,
      icon: 'success'
    })
  }


  alertSuccessDismiss(msg:string){
    Swal.fire({
      position: 'top-end',
      icon: 'success',
      title: `${msg}`,
      showConfirmButton: false,
      timer: 1000
    })
  }

  alertWarning(item:string){

    return Swal.fire({
      icon: 'warning',
      text: `¿Esta seguro que quiere borrar "${item}" ?`,
      showCancelButton: true,
    })


  }


  alertWarningText(text:string){
    return Swal.fire({
      icon: 'warning',
      title: 'Alert',
      text: `${text}`,
    })
  }

  confirmOut(){
    return Swal.fire({
      icon: 'question',
      text: 'Aún no ha guardado, ¿Seguro/a desea salir?',
      showCancelButton: true
    }).then(val => val.value ? true : false)
  }

  typeModal(icon,title,btnCancel,btnSuccess){
    return Swal.fire({
      icon: icon,
      text: title,
      showCancelButton: true,
      cancelButtonText:btnCancel,
      confirmButtonText: btnSuccess,
      confirmButtonColor: '#1977DF',
      cancelButtonColor: '#1977DF',
    }).then(val => val.value ? true : false)
  }

  existContact(info){
    return Swal.fire({
      icon: 'warning',
      text: `Este número esta asignado a ${info.name} ${info.lastname}`,
      showCancelButton: true,
    })
  }



}
